import React, { useEffect, useState } from "react";
import AddLayout from "../../../component/AddLayout";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  FormControl,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { addDiscardSeed, getBranchList } from "../services/api";
import api from "../../../api/api";
import RequireSelect from "../../../component/RequireSelect";
import RequireField from "../../../component/RequireField";
import { getData, patchData, postData } from "../../../services/api";
import Swal from "sweetalert2";

export default function AddCost() {
  const breedClass = [
    {
      value: "หลัก",
    },
    {
      value: "ขยาย",
    },
    {
      value: "จำหน่าย",
    },
  ];

  const seasons = [
    {
      value: "แล้ง",
    },
    {
      value: "ฝน",
    },
  ];
  const { profile } = useSelector((state) => state.profile);
  const canRead = profile?.Permissions?.find((x) => x?.Action === 'Cost.Read')?.Permit;
  const canUpdate = profile?.Permissions?.find((x) => x?.Action === 'Cost.Update')?.Permit;
  const [branchs, setBranchs] = useState([]);
  const [seasonsNo, setSeasonsNo] = useState("ทั้งหมด");
  const [breedClassNo, setBreedClassNo] = useState("ทั้งหมด");
  const [CatalogNo, setCatalogNo] = useState("ALL");
  const [Year, setYear] = useState();
  const [LotStart, setLotStart] = useState();
  const [LotEnd, setLotEnd] = useState();
  const [costNum, setCostNum] = useState();
  const [BranchNo, setBranchNo] = useState();
  const [cheackAll, setCheackAll] = useState(false);
  const [open, setOpen] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [dataItemCatalogs, setDataItemCatalogs] = useState([]);

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleCheckAll = () => {
    setCheackAll(!cheackAll);
    const item = rows?.map((v, index) => {
      v.isCheck = !cheackAll;
      return v;
    });
    setRows([...item]);
  };
  const getItemCatalogs = async () => {
    const res = await api.get(`dbms/itemcatalogs`);
    const data = await res.data.result;
    if (res.data.status === true) {
      setDataItemCatalogs(data);
    }
  };

  const getBranch = async () => {
    const data = await getBranchList();
    setBranchs(data);
  };
  const getList = async () => {
    let query = {
      BranchNo: BranchNo || profile?.BranchNo?.BranchNo,
    };
    if (CatalogNo !== "ALL") query = { ...query, CatalogNo: CatalogNo };
    if (breedClassNo !== "ทั้งหมด") query = { ...query, Class: breedClassNo };
    if (seasonsNo !== "ทั้งหมด") query = { ...query, Season: seasonsNo };
    if (Year) query = { ...query, Year: Year };
    if (LotStart) query = { ...query, StartLot: LotStart };
    if (LotEnd) query = { ...query, EndLot: LotEnd };

    setLoading(true);
    const res = await getData(`stock/production_cost`, "", query);
    if (res.status === true) {
      const data = res.result;
      console.log(data);
      setRows(data);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
    }
  };
  useEffect(() => {
    getBranch();
    getItemCatalogs();
    setBranchNo(profile?.BranchNo?.BranchNo);
  }, []);
  const head = [
    "CHECKBOX",
    "ที่",
    "เมล็ดพันธุ์",
    "ชั้นพันธุ์",
    "ฤดู",
    "กลุ่มพันธุ์",
    "สารเคมี",
    "ปีที่ผลิต",
    "ล็อตที่",
    "ปริมาณ (กก.)",
    "ต้นทุนการผลิต",
  ];
  const body = rows?.map((x, i) => {
    return {
      item1: (
        <>
          <Checkbox
            checked={x?.isCheck || ""}
            onChange={(e) => {
              const item = rows?.map((v, index) => {
                v.isCheck = i === index ? e.target.checked : v?.isCheck;
                return v;
              });
              setRows([...item]);
            }}
          />
        </>
      ),
      item2: i + 1,
      item3: x?.ItemName,
      item4: x?.Option2,
      item5: (
        <span
          style={{
            color: x?.Season === "ฝน" ? "#0D9206" : "brown",
            fontWeight: "bold",
          }}
        >
          {x?.Season}
        </span>
      ),
      item6: x?.Option1,
      item7: x?.Chemical,
      item8: x?.Year,
      item9: x?.Lot,
      item10: x?.Qty?.toLocaleString(),
      item11: (
        <TextField
          sx={{ width: "150px" }}
          type="number"
          value={x?.CostPrice}
          size="small"
          fullWidth
          variant="outlined"
          disabled={!canUpdate}
          onChange={(e) => {
            const item = rows?.map((v, index) => {
              v.CostPrice = i === index ? e.target.value : v?.CostPrice;
              return v;
            });
            setRows([...item]);
          }}
        />
      ),
    };
  });
  const inputHead = [
    {
      name: "ศูนย์เมล็ดพันธุ์ข้าว",
      inputComponent: (
        <>
          {profile?.BranchNo?.BranchNo === "00" && (
            <Box className="backgroundField" sx={{ marginRight: "20px" }}>
              <FormControl variant="standard" fullWidth>
                <Select
                  value={BranchNo || ""}
                  onChange={(e) => {
                    setBranchNo(e.target.value);
                  }}
                  disableUnderline
                  MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                >
                  {branchs?.map((x, i) => (
                    <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          )}
        </>
      ),
    },
    {
      name: "",
      inputComponent: <></>,
    },
    {
      name: "พันธุ์ข้าว",
      inputComponent: (
        <>
          <RequireSelect
            value={CatalogNo}
            onChange={setCatalogNo}
            menu={[
              { CatalogNo: "ALL", CatalogName: "ทั้งหมด" },
              ...dataItemCatalogs,
            ]?.map((x, i) => (
              <MenuItem key={i} value={x?.CatalogNo}>
                {x?.CatalogName}
              </MenuItem>
            ))}
            // disabled={id ? true : false}
            // error={CatalogError}
            // setError={setCatalogError}
            textError={"กรุณาเลือกพันธุ์ข้าว"}
          />
        </>
      ),
    },
    {
      name: "ชั้นพันธุ์",
      inputComponent: (
        <>
          <RequireSelect
            value={breedClassNo}
            onChange={setBreedClassNo}
            menu={[{ value: "ทั้งหมด" }, ...breedClass]?.map((x, i) => (
              <MenuItem key={i} value={x?.value}>
                {x?.value}
              </MenuItem>
            ))}
            // disabled={id ? true : false}
            // error={breedClassError}
            // setError={setBreedClassError}
            textError={"กรุณาเลือกชั้นพันธุ์"}
          />
        </>
      ),
    },
    {
      name: "ฤดู",
      inputComponent: (
        <>
          <RequireSelect
            value={seasonsNo}
            onChange={setSeasonsNo}
            menu={[{ value: "ทั้งหมด" }, ...seasons]?.map((x, i) => (
              <MenuItem key={i} value={x?.value}>
                {x?.value}
              </MenuItem>
            ))}
            // disabled={id ? true : false}
            // error={seasonsError}
            // setError={setSeasonsError}
            textError={"กรุณาเลือกฤดู"}
          />
        </>
      ),
    },
    {
      name: "ปี",
      inputComponent: (
        <>
          <RequireField
            value={Year}
            onChange={setYear}
            type={"number"}
            inputProps={{ maxLength: 4 }}
            // error={SalePriceError}
            // setError={setSalePriceError}
            // textError={"กรุณากรอกราคา"}
          />
        </>
      ),
    },
    {
      name: "ล็อตเริ่มต้น",
      inputComponent: (
        <>
          <RequireField
            value={LotStart}
            onChange={setLotStart}
            type={"number"}
            inputProps={{ maxLength: 3 }}
            // error={SalePriceError}
            // setError={setSalePriceError}
            // textError={"กรุณากรอกราคา"}
          />
        </>
      ),
    },
    {
      name: "ล็อตสิ้นสุด",
      inputComponent: (
        <>
          <RequireField
            value={LotEnd}
            onChange={setLotEnd}
            type={"number"}
            inputProps={{ maxLength: 3 }}
            // error={SalePriceError}
            // setError={setSalePriceError}
            // textError={"กรุณากรอกราคา"}
          />
        </>
      ),
    },
    {
      name: "",
      inputComponent: (
        <>
          <Button
            variant="contained"
            onClick={() => getList()}
            sx={{ width: "130px", fontSize: "14px", marginTop: "20px" }}
          >
            {"ค้นหา"}
          </Button>
        </>
      ),
    },
  ];
  const handleSubmit = async () => {
    const body = {
      Items: rows?.map((item) => {
        return {
          ReceiveDetailId: item?.ReceiveDetailId,
          CostPrice: item?.CostPrice
        };
      }),
    };
    setLoadingSubmit(true);
    const res = await patchData(`stock/production_cost`, body);
    const data = res.result;
    if (data) {
      setLoadingSubmit(false);
      setOpen(false);
      // navigate("/stock/stock-culled/" + res.DocumentNo, {
      //   state: { new: true },
      // });
      Swal.fire({
        title: "ทำรายการสำเร็จ",
        icon: "success",
      });
      setRows([])
      setBranchNo(profile?.BranchNo?.BranchNo)
      setBreedClassNo('ทั้งหมด')
      setSeasonsNo('ทั้งหมด')
      setYear('')
      setLotStart('')
      setLotEnd('')
      setCatalogNo('ALL')
      setCheackAll(false)
      setCostNum(null)
    } else {
      Swal.fire({
        title: "ทำรายการไม่สำเร็จ",
        icon: "warning",
      });
      setLoadingSubmit(false);
    }
  };
  if (profile && !canRead) {
    return (
      <div class="text-center" style={{ padding: "40px" }}>
        <label class="title-content">ไม่มีสิทธิ์เข้าถึงหน้าต้นทุนการผลิต</label>
      </div>
    );
  }
  return (
    <AddLayout
      title={"ต้นทุนการผลิต"}
      inputHead={inputHead}
      bodyTitle={"รายการต้นทุนการผลิต"}
      bodyAction={
        canUpdate &&
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <RequireField
            value={costNum || ''}
            onChange={setCostNum}
            type={"number"}
            // inputProps={{ maxLength: 3 }}
            placeholder="ระบุต้นทุนการผลิต"
            // error={SalePriceError}
            // setError={setSalePriceError}
            // textError={"กรุณากรอกราคา"}
          />
          <Button
            variant="contained"
            onClick={() => {
              const item = rows?.map((v, index) => {
                v.CostPrice = true === v?.isCheck ? costNum : v?.CostPrice;
                return v;
              });
              setRows([...item]);
            }}
            sx={{ width: "130px", fontSize: "14px" }}
          >
            {"ปรับทั้งหมด"}
          </Button>
        </div>
      }
      cheackAll={cheackAll}
      handleCheckAll={handleCheckAll}
      tableHead={head}
      tableBody={body}
      tableHeight={rows.length > 0 && 600}
      bootomAction={
        <>
          {canUpdate &&
            <Button
              variant="contained"
              onClick={() => setOpen(true)}
              sx={{ width: "130px", fontSize: "14px" }}
            >
              {"บันทึก"}
            </Button>}
        </>
      }
      dialog={
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          fullWidth
          maxWidth="xl"
        >
          <DialogContent>
            <div class="d-flex row align-items-center mb-4">
              <div class="col-12">
                <label
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "700",
                    color: "#3364af",
                  }}
                >
                  รายการต้นทุนการผลิต {/* {{data?.header}} */}
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 table-responsive-sm ">
                <table class="table table-borderless  ">
                  <thead>
                    <tr>
                      {head?.map((item, i) => {
                        if (item === "CHECKBOX") {
                          return <></>;
                        }
                        return (
                          <th key={i} class="text-center">
                            {item}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody class="">
                    {rows?.map((creds, i) => (
                      <tr>
                        <td class="text-center">{i + 1}.</td>
                        <td class="text-center">{creds?.ItemName}</td>
                        <td class="text-center">{creds?.Option2}</td>
                        <td class="text-center">
                          <span
                            style={{
                              fontWeight: "bold",
                              color:
                                creds?.Season === "ฝน" ? "#0D9206" : "brown",
                            }}
                          >
                            {creds?.Season}{" "}
                          </span>
                        </td>
                        <td class="text-center">{creds?.Option1}</td>
                        <td class="text-center">{creds?.Chemical}</td>
                        <td class="text-center">{creds?.Year}</td>
                        <td class="text-center">{creds?.Lot}</td>

                        <td class="text-center">
                          {creds?.Qty?.toLocaleString()}
                        </td>

                        <td class="text-center">
                          {creds?.CostPrice.toLocaleString()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-12 text-end">
                <Button
                  onClick={() => setOpen(false)}
                  variant="outlined"
                  sx={{ width: "150px", marginRight: "20px" }}
                >
                  ยกเลิก
                </Button>
                <Button
                  disabled={loadingSubmit}
                  onClick={() => handleSubmit()}
                  variant="contained"
                  sx={{ width: "150px", marginRight: "20px" }}
                >
                  {loadingSubmit ? (
                    <CircularProgress size={"24px"} color="inherit" />
                  ) : (
                    "ยืนยันการทำรายการ"
                  )}
                </Button>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      }
    />
  );
}
